import { themePalette } from "../config/theme.config"

export const Footer: React.FC<{}> = () =>{

    return (
        <div style={{
            minHeight: '10vh', // Mínimo 100% del alto de la ventana
            display: 'flex',
            flexDirection: 'column',
            marginTop: 'auto'
        }}>
      <div>
        {/* Contenido principal de tu página */}
      </div>
      <div style={{
        flex: 1, // Hace que el pie de página ocupe el espacio disponible
        backgroundColor: themePalette.BGWHITE,
        color: themePalette.COLOR_FONT_FOOTER,
        textAlign: 'center',
        fontSize: '0.65em',
      }}>
        <p>
          Escuela Superior Politécnica del Litoral - Campus Gustavo Galindo - Guayaquil - Ecuador
          <br />
          &copy; El contenido de esta obra es de propiedad de la ESPOL. Todos los derechos reservados.
          <br />
          Prohibida su reproducción total o parcial, comunicación pública o distribución sin autorización previa del titular de los derechos.
        </p> 
      </div>
    </div>
    )
}